import React from 'react';
import { Typography, Grid, Container, Button, Card, Paper } from '@mui/material';

const Block6 = (props) => {

    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={'xl'}
            sx={{
                marginTop: "20px"
            }}
        >
            <Card elevation={5} sx={{ borderRadius: 5, margin: "30px" }}>
                <Grid container item md={12} justifyContent={'center'} direction={'row'} alignItems={'center'}>
                    <Grid container item md={6} >
                        <Typography
                            variant={'h1'}
                            sx={{
                                fontSize: {
                                    xs: "14px",
                                    md: "25px"
                                },
                                fontWeight: "bold",
                                margin: {
                                    xs: "20px",
                                    md: "80px"
                                }
                            }}
                        >
                            Quick Quotes in minutes, Subscribe Today
                        </Typography>

                        <Typography
                            align='justify'
                            sx={{
                                fontSize: {
                                    xs: "14px",
                                    md: "20px"
                                },
                                color: "#808291",
                                margin: {
                                    xs: "0px 20px",
                                    md: "0px 0px 40px 40px"
                                },

                            }}
                        >
                            Tirefax can tailor a subscription to meet your specific requirements and will customize plans for larger organizations and enterprises. In most cases, auto dealers, auto service retailers, fleets, auction yards and rental agencies can expect a quote in minutes after we gather some basic information.
                        </Typography>



                        <Grid container item md={1} />
                    </Grid>
                    <Grid container item md={6} direction="row" justifyContent={'center'} alignItems={"center"} alignContent={'center'}>

                        <Button disableElevation variant='contained' size="large"
                            sx={{
                                backgroundColor: "#FE753E",
                                margin: "10px", color: "#FFF",
                                fontWeight: "bold", borderRadius: "50px", padding: "20px"

                            }}>
                            Get Started Now
                        </Button>

                    </Grid>

                </Grid>
            </Card>
        </Container>
    )
}

export default Block6;